import { KeychainAccess, SecureStorage as CapacitorSecureStorage } from "@aparajita/capacitor-secure-storage";
import type { SecureStorage } from "@fluentry/platform-adapters";

const KEY_PREFIX = "fluentry_mobile_";

let initialized = false;

async function ensureNativeSecureStorageConfigured() {
  if (initialized) {
    return;
  }

  await CapacitorSecureStorage.setKeyPrefix(KEY_PREFIX);
  await CapacitorSecureStorage.setDefaultKeychainAccess(KeychainAccess.whenUnlockedThisDeviceOnly);
  initialized = true;
}

export function createNativeSecureStorage(): SecureStorage {
  return {
    async get(key) {
      await ensureNativeSecureStorageConfigured();
      return CapacitorSecureStorage.getItem(key);
    },
    async set(key, value) {
      await ensureNativeSecureStorageConfigured();
      await CapacitorSecureStorage.setItem(key, value);
    },
    async remove(key) {
      await ensureNativeSecureStorageConfigured();
      await CapacitorSecureStorage.removeItem(key);
    },
  };
}
